import { GET_ADMIN_PAYMENT_TYPES_REQUEST, GET_ADMIN_PAYMENT_TYPES_SUCCESS, GET_ADMIN_PAYMENT_TYPES_ERROR } from "../actions/types";
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_ADMIN_PAYMENT_TYPES_REQUEST:
            return {
                loading: true,
            };
        case GET_ADMIN_PAYMENT_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                payload
            };
        case GET_ADMIN_PAYMENT_TYPES_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };
        default:
            return state;
    }
}
